import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BreachesComponent } from './breaches/breaches.component';
import { ComplianceComponent } from './compliance/compliance.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { LawsComponent } from './laws/laws.component';
import { ManageBreachComponent } from './manage-breach/manage-breach.component';
import { ManageFeesComponent } from './manage-fees/manage-fees.component';
import { ManageLawComponent } from './manage-law/manage-law.component';
import { ManageMaintenanceComponent } from './manage-maintenance/manage-maintenance.component';
import { ManageMortgageComponent } from './manage-mortgage/manage-mortgage.component';
import { PremisesComponent } from './premises/premises.component';
import { QueryMaintenanceComponent } from './query-maintenance/query-maintenance.component';
import { RegistrationComponent } from './registration/registration.component';
import { StatementComponent } from './statement/statement.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { AuthGuard } from './_helpers/auth.guard';
import { Role } from './_models/role';
import { ManagePropertyComponent } from './manage-property/manage-property.component';
import { ManagePropertyMenuComponent } from './manage-property-menu/manage-property-menu.component';
import { GenerateMaintenanceComponent } from './generate-maintenance/generate-maintenance.component';
import { ManageRatesComponent } from './manage-rates/manage-rates.component';
import { ManagePremisesComponent } from './manage-premises/manage-premises.component';
import { NoticesComponent } from './notices/notices.component';
import { ManagePaymentsComponent } from './manage-payments/manage-payments.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { PaymentComponent } from './payment/payment.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ComplaintsComponent } from './complaints/complaints.component';
import { ManageComplaintsComponent } from './manage-complaints/manage-complaints.component';
import { ManageNoticesComponent } from './manage-notices/manage-notices.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ResetPassword } from './reset-password/reset-password';

const routes: Routes = [
  {
    component: HomeComponent,
    path: "home",
    canActivate: [AuthGuard]
  },
  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full",
  },
  {
    path: "query-maintenance",
    component: QueryMaintenanceComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: 'delete-account/:action',
    component: DeleteAccountComponent
  },
  {
    path: 'delete-account',
    component: DeleteAccountComponent
  },
  {
    path: "statement",
    component: StatementComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-property/:action",
    component: ManagePropertyComponent,
    data: { roles: [Role.ROLE_ADMIN, Role.ROLE_SUPER]},
    canActivate: [AuthGuard],
  },
  {
    path: "manage-mortgage/:action",
    component: ManageMortgageComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
    {
    path: "manage-notices/:action",
    component: ManageNoticesComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-notices",
    component: ManageNoticesComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-premises/:action",
    component: ManagePremisesComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
  },
  {
    path: "manage-property",
    component: ManagePropertyComponent,
    data: { roles: [Role.ROLE_ADMIN, Role.ROLE_SUPER]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "manage-property-menu",
    component: ManagePropertyMenuComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "generate-maintenance",
    component: GenerateMaintenanceComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "manage-rates",
    component: ManageRatesComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "compliance",
    //redirectTo: "compliance/index",
    component: ComplianceComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "manage-breaches",
    component: ManageBreachComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-breaches/:action",
    component: ManageBreachComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "breaches",
    component: BreachesComponent,
    //data: { roles: [Role.ROLE_USER]},
    //canActivate: [AuthGuard]
  },
  {
    path: "manage-laws/:action",
    component: ManageLawComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-laws",
    component: ManageLawComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "laws",
    component: LawsComponent,
    data: { roles: [Role.ROLE_USER]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-fees/:action",
    component: ManageFeesComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
  },
  {
    path: "premises/:action",
    component: PremisesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "premises",
    component: PremisesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "payments/:action",
    component: PaymentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "subscription",
    component: SubscriptionComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-subscription",
    component: SubscriptionComponent,
    data: { roles: [Role.ROLE_ADMIN, Role.ROLE_SUPER]},
    canActivate: [AuthGuard]
  },
  {
    path: "notices",
    component: NoticesComponent,
    canActivate: [AuthGuard]

  },
  {
    path: "complaints",
    component: ComplaintsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "manage-complaints/:action",
    component: ManageComplaintsComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard]
  },
  {
    path: "manage-complaints",
    component: ManageComplaintsComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
    pathMatch: "full"
  },
  {
    path: "manage-payments/:action",
    component: ManagePaymentsComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
  },
  {
    path: "manage-maintenance/:action",
    component: ManageMaintenanceComponent,
    data: { roles: [Role.ROLE_ADMIN]},
    canActivate: [AuthGuard],
  },
  {
    path: "compliance/:action",
    data: { roles: [Role.ROLE_ADMIN]},
    component: ComplianceComponent,
    canActivate: [AuthGuard]

  },
  {
    path: "register",
    component: RegistrationComponent
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "verify/account/:email/:token",
    component: VerifyAccountComponent
  },
  {
    path: "forget-password",
    component: ForgetPasswordComponent
  },
  {
    path: "reset-password",
    component: ResetPassword,
  },
  {
    path: 'change-password/:token',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard]
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
